import { render, staticRenderFns } from "./agentHaokaOrder.vue?vue&type=template&id=0563828d&scoped=true&"
import script from "./agentHaokaOrder.vue?vue&type=script&lang=js&"
export * from "./agentHaokaOrder.vue?vue&type=script&lang=js&"
import style0 from "./agentHaokaOrder.vue?vue&type=style&index=0&id=0563828d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0563828d",
  null
  
)

export default component.exports